import Icd10CodeModal from './Icd10CodeModal';

export default Icd10CodeModal;
